// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18bae8ae","239":"47dfb5d7","732":"0fd150f4"}[chunkId] + ".chunk.js";
};